<template>
  <div>
    <template v-if="!isEditing">
      <el-dropdown trigger="click">
        <div class="dropdown-btn-wrapper">
          <i :class="icon"></i>
          <el-dropdown-menu slot="dropdown">
            <rest-list-action
              v-if="isUpdatable"
              icon="el-icon-edit-outline"
              :title="$t('RestList_Action_Update')"
              :click="edit"
            />
            <slot />
          </el-dropdown-menu>
        </div>
      </el-dropdown>
    </template>
    <template v-else>
      <rest-list-action
        icon="ico icon-floppy actions-button-save"
        :title="$t('RestList_Action_Save')"
        :click="save"
      />
      <rest-list-action
        icon="el-icon-circle-close"
        :click="cancel"
        :title="$t('RestList_Action_Cancel')"
      />
    </template>
  </div>
</template>

<script>
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionEdit',

  components: { RestListAction },
  inject: [
    'editRow',
    'saveChanges',
    'cancelChanges',
    'isEditingRow',
    'isUpdatable'
  ],

  props: {
    icon: {
      required: true
    },
    index: {
      required: true
    }
  },
  methods: {
    edit() {
      this.editRow(this.index)
    },
    save() {
      this.saveChanges(this.index)
    },
    cancel() {
      this.cancelChanges(this.index, true)
    }
  },
  computed: {
    isEditing() {
      return this.isEditingRow(this.index)
    }
  }
}
</script>
<style scoped>
>>> .actions-button-save {
  background-color: #1d87c8;
  border-color: #1d87c8;
  color: #ffffff;
  border-radius: 4px;
  transition: all 0.3s;
}

>>> .actions-button-save:hover {
  background-color: #53aee6;
  border-color: #53aee6;
  color: #ffffff;
  cursor: pointer;
}

.dropdown-btn-wrapper .el-icon-more {
  cursor: pointer;
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionEdit.vue